module.exports = __webpack_public_path__ + "static/media/count_down_icon.f6589813.svg";